import React from 'react';
import { useAlertasFraude, AlertaExcesso, AlertaDuplo } from 'src/controllers/Dashboard/FleetAdmin/AlertasFraudeController';

const timeAgo = (horaRaw: string): string => {
    const d = new Date(horaRaw);
    const diff = Math.floor((Date.now() - d.getTime()) / 60000);
    if (diff < 1) return 'agora';
    if (diff < 60) return `há ${diff} min`;
    const h = Math.floor(diff / 60);
    if (h < 24) return `há ${h}h`;
    return `há ${Math.floor(h / 24)}d`;
};

const wrapStyle: React.CSSProperties = {
    background: '#1e1e2e',
    borderRadius: 16,
    padding: '1.2rem 1.4rem',
    marginBottom: '1.5rem',
};

const headerStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
};

const itemStyle: React.CSSProperties = {
    background: '#2d1a1a',
    borderRadius: 12,
    padding: '0.9rem 1rem',
    marginBottom: 10,
    display: 'flex',
    gap: 12,
    alignItems: 'flex-start',
    position: 'relative',
};

const iconBoxStyle: React.CSSProperties = {
    background: '#7f1d1d',
    borderRadius: 10,
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    fontSize: 18,
};

const CardExcesso: React.FC<{ alerta: AlertaExcesso }> = ({ alerta }) => (
    <div style={itemStyle}>
        <div style={iconBoxStyle}>⚠️</div>
        <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#f87171', fontSize: 11, fontWeight: 700, textTransform: 'uppercase' }}>
                    Crítico
                </span>
                <span style={{ color: '#a0aec0', fontSize: 11 }}>{timeAgo(alerta.hora)}</span>
            </div>
            <div style={{ color: '#fff', fontWeight: 600, fontSize: 15, marginTop: 2 }}>
                Excesso de capacidade de tanque
            </div>
            <div style={{ color: '#f87171', fontSize: 13, marginTop: 4 }}>
                {alerta.placa} — Abasteceu {alerta.litros.toLocaleString('pt-BR')} L.
                Capacidade máxima: {alerta.capacidade.toLocaleString('pt-BR')} L
            </div>
        </div>
    </div>
);

const CardDuplo: React.FC<{ alerta: AlertaDuplo }> = ({ alerta }) => (
    <div style={itemStyle}>
        <div style={iconBoxStyle}>🔄</div>
        <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#f87171', fontSize: 11, fontWeight: 700, textTransform: 'uppercase' }}>
                    Crítico
                </span>
                <span style={{ color: '#a0aec0', fontSize: 11 }}>{timeAgo(alerta.hora2)}</span>
            </div>
            <div style={{ color: '#fff', fontWeight: 600, fontSize: 15, marginTop: 2 }}>
                Duplo abastecimento em menos de 8h
            </div>
            <div style={{ color: '#f87171', fontSize: 13, marginTop: 4 }}>
                {alerta.placa} — Mesmo veículo abasteceu duas vezes em {alerta.diffHoras}h
                ({alerta.litros1.toLocaleString('pt-BR')} L + {alerta.litros2.toLocaleString('pt-BR')} L)
            </div>
        </div>
    </div>
);

const AlertasFraudeCard: React.FC = () => {
    const { data, loading } = useAlertasFraude();

    const todos: (AlertaExcesso | AlertaDuplo)[] = [
        ...data.excessoCapacidade,
        ...data.duploAbastecimento,
    ].sort((a, b) => {
        const ta = new Date(a.tipo === 'EXCESSO_CAPACIDADE' ? a.hora : a.hora2).getTime();
        const tb = new Date(b.tipo === 'EXCESSO_CAPACIDADE' ? b.hora : b.hora2).getTime();
        return tb - ta;
    });

    if (!loading && todos.length === 0) return null;

    return (
        <div style={wrapStyle}>
            <div style={headerStyle}>
                <span style={{ color: '#fff', fontWeight: 700, fontSize: 18 }}>
                    ⚠️ Alertas de Fraude
                </span>
                {data.total > 0 && (
                    <span style={{
                        background: '#ef4444',
                        color: '#fff',
                        borderRadius: 20,
                        padding: '2px 12px',
                        fontSize: 13,
                        fontWeight: 700,
                    }}>
                        {data.total}
                    </span>
                )}
            </div>

            {loading ? (
                <div style={{ textAlign: 'center', padding: '1rem' }}>
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.5em', color: '#fff' }} />
                </div>
            ) : (
                todos.slice(0, 10).map((alerta, i) =>
                    alerta.tipo === 'EXCESSO_CAPACIDADE'
                        ? <CardExcesso key={i} alerta={alerta as AlertaExcesso} />
                        : <CardDuplo key={i} alerta={alerta as AlertaDuplo} />
                )
            )}
        </div>
    );
};

export default AlertasFraudeCard;
